import { render, staticRenderFns } from "./ClaimsExtractor.vue?vue&type=template&id=576e551e"
import script from "./ClaimsExtractor.vue?vue&type=script&lang=js"
export * from "./ClaimsExtractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports